'use client';
/** Возвращает индекс предыдущего элемента, свойство disabled которого неистинно */ const getPreviousIndex = (current, elements, loop)=>{
    for(let i = current - 1; i >= 0; i -= 1){
        if (!elements[i].disabled) {
            return i;
        }
    }
    if (loop) {
        for(let i = elements.length - 1; i > -1; i -= 1){
            if (!elements[i].disabled) {
                return i;
            }
        }
    }
    return current;
};

export { getPreviousIndex };
//# sourceMappingURL=getPreviousIndex.js.map
